import { Link } from 'react-router-dom';
import Logo from '../assets/images/Logo.svg';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// icons + images
import pfas from '../assets/images/pfas_photos.png';
import personalCare from '../assets/svg/products/personal_care_products.svg';
import firefightinFoam from '../assets/svg/products/firefighting_foams.svg';
import waterResistantClothing from '../assets/svg/products/water_resistant_clothing.svg';
import paint from '../assets/svg/products/paint.svg';
import nonStickCookware from '../assets/svg/products/non_stick_cookware.svg';
import fastFood from '../assets/svg/products/fast_food_package.svg';
import furniture from '../assets/svg/products/stain_resistant_furniture.svg';
import stainResistantProduct from '../assets/svg/products/stain_resistant_product.svg';
import popcornBag from '../assets/svg/products/microwave_popcorn_bags.svg';
import pesticides from '../assets/svg/products/pesticides.svg';
import photography from '../assets/svg/products/photography.svg';
import cosmetics from '../assets/svg/products/cosmetics.svg';

function Pfas() {
  const products = [
    { id: 0, text: 'Personal care products', img: personalCare },
    { id: 1, text: 'Firefighting foams', img: firefightinFoam },
    { id: 2, text: 'Water-resistant clothing', img: waterResistantClothing },
    { id: 3, text: 'Paint', img: paint },
    { id: 4, text: 'Nonstick cookware', img: nonStickCookware },
    { id: 5, text: 'Fast food packaging', img: fastFood },
    { id: 6, text: 'Stain-resistant furniture', img: furniture },
    { id: 7, text: 'Stain-resistant products', img: stainResistantProduct },
    { id: 8, text: 'Microwave popcorn bags', img: popcornBag },
    { id: 9, text: 'Pesticides', img: pesticides },
    { id: 10, text: 'Photography', img: photography },
    { id: 11, text: 'Cosmetics', img: cosmetics },
  ];
  return (
    <>
      <div className='navigation'>
        <div className='logo'>
          <img src={Logo} alt='Quantum logo' />
        </div>
        <div className='nav'>
          <Link to='/map' className='pfas-btn-white-back'>
            <div className='nav-text-back'>Previous</div>
          </Link>
          <Link to='/'>
            <div className='nav-home'></div>
          </Link>
          <div className='nav-page-nr'>2/6</div>
          <Link to='/pfasimpacts' className='pfas-btn-blue-next'>
            <div className='nav-text-next'>Next</div>
          </Link>
        </div>
      </div>

      <div className='pfas pfas-container'>
        <Row>
          <div className='about-pfas'>
            <Col xs={12} lg={6}>
              <div className='text-left'>
                <div className='slogan'>Basic definition</div>
                <div className='headline'>What is PFAS?</div>
                <div className='text'>
                  PFAS are human-made chemicals used for waterproof clothing,
                  non-stick pans, food packaging, etc. They are designed to be
                  tough using carbon-fluorine bonds – one of the strongest
                  chemical bonds. Thus, PFAS don’t biodegrade, and are known
                  as “the forever chemicals.”
                </div>
                <div className='products-headline'>Products with PFAS:</div>
                <div className='products-list'>
                  {products.map((prod) => {
                    return (
                      <div className='singe-product-block' key={prod.id}>
                        <object data={prod.img} aria-label={prod.text} />
                        <div className='products-name'>{prod.text}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <div className='image-right'>
                <img src={pfas} alt='In these products you can find PFAS'></img>
              </div>
            </Col>
          </div>
        </Row>
      </div>
    </>
  );
}

export default Pfas;
